import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { StateProvider } from "./stores/application.store";
import { LocaleProvider } from "./stores/locale.store";
import { MapContextProvider } from "./stores/map.store";
import { TimelineProvider } from "./stores/timeline.store";
import { VotingDataProvider } from "./stores/voting.store";

ReactDOM.render(
  <React.StrictMode>
    <StateProvider>
      <LocaleProvider>
        <TimelineProvider>
          <VotingDataProvider>
            <MapContextProvider>
              <App />
            </MapContextProvider>
          </VotingDataProvider>
        </TimelineProvider>
      </LocaleProvider>
    </StateProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
